import React, { useState } from "react";
import { ListPlus, Trash2 } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";

const slug = (s) => "cf_" + s.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 40);

export default function TaskCustomFieldsButton({ fields, onChange, disabled }) {
  const [label, setLabel] = useState("");
  const add = (e) => {
    e.preventDefault();
    const l = label.trim();
    if (!l) return;
    let key = slug(l) || `cf_${Date.now()}`;
    while (fields.some((f) => f.key === key)) key += "_2";
    onChange([...fields, { key, label: l }]);
    setLabel("");
  };
  const remove = (f) => {
    if (!window.confirm(`Remove the "${f.label}" field? Values already entered in it will be hidden.`)) return;
    onChange(fields.filter((x) => x.key !== f.key));
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button disabled={disabled} data-testid="task-custom-fields-btn" className="inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm border border-slate-700 text-slate-300 hover:border-blue-500 disabled:opacity-50">
          <ListPlus size={14} /> Fields{fields.length ? ` (${fields.length})` : ""}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72" data-testid="task-custom-fields-popover">
        <div className="text-xs uppercase tracking-widest text-slate-400 mb-2">Custom task fields</div>
        <p className="text-[11px] text-slate-500 mb-3">Added to this project's task table only. Saved with templates made from this project.</p>
        {fields.length > 0 && (
          <ul className="space-y-1 mb-3" data-testid="task-custom-fields-list">
            {fields.map((f) => (
              <li key={f.key} className="flex items-center justify-between text-sm" data-testid={`task-custom-field-${f.key}`}>
                <span className="truncate">{f.label}</span>
                <button onClick={() => remove(f)} data-testid={`task-custom-field-remove-${f.key}`} className="text-slate-500 hover:text-rose-400"><Trash2 size={13} /></button>
              </li>
            ))}
          </ul>
        )}
        <form onSubmit={add} className="flex gap-2">
          <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Field name, e.g. Cost center" maxLength={40}
            data-testid="task-custom-field-input" className="flex-1 min-w-0 px-2 py-1.5 rounded border focus:outline-none focus:border-blue-500 text-sm" />
          <button type="submit" data-testid="task-custom-field-add" className="bg-blue-600 hover:bg-blue-500 text-white px-3 py-1.5 rounded text-sm">Add</button>
        </form>
      </PopoverContent>
    </Popover>
  );
}
